import { SanityClient } from "@sanity/client";

export const cmsLogout = async (client: SanityClient) => {
  // https://www.sanity.io/docs/js-client#clientauth-is-removed-replace-with-clientrequest
  await client.request<void>({ uri: "/auth/logout", method: "POST" }); // Logout from Sanity
  await fetch("/api/internal/preview?disable=true"); // Disable preview mode, clears the __prerender_bypass cookie from next.js
  localStorage.removeItem(getAuthTokenKey(client)); // Clears sanity auth token from local storage. Not sure if this is needed, but it doesn't hurt to clear the localStorage token as well
};

const getAuthTokenKey = (client: SanityClient) => `__studio_auth_token_${client.config().projectId}`;

// Sanity uses localStorage for authtoken when logging in with some browsers (ie. Firefox and safari), while for Chrome Sanity uses cookies
export const getSanityAuthTokenFromLocalStorage = (client: SanityClient): string | undefined => {
  if (typeof window === "undefined" || !localStorage) return undefined;

  const localStorageToken = localStorage.getItem(getAuthTokenKey(client));

  if (!localStorageToken) return undefined;

  try {
    return JSON.parse(localStorageToken)?.token;
  } catch (err) {
    console.error("Could not parse Sanity auth token from localStorage:", err);
    return undefined;
  }
};
